import React, { useRef, useEffect, useState } from 'react';
import { Container, Typography, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import ReactToPrint from 'react-to-print'; // Optional: You can use react-to-print for better control
import { formatDate } from './utils/date';
import { useT } from '../i18n/LanguageContext';

// Component to Display Each Invoice
const InvoiceDisplay = React.forwardRef(({ invoiceData }, ref) => {
    const t = useT();
    return (
      <Container ref={ref} maxWidth="md" sx={{ mb: '40px', p: { xs: 1.5, sm: '20px' }, border: '1px solid #ccc' }}>
        {/* Company Information */}
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom sx={{ overflowWrap: 'anywhere' }}>{t('inv.companyName')}: {invoiceData.companyName}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{t('inv.address')}: {invoiceData.companyAddress}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{t('inv.phone')}: {invoiceData.companyPhone}</Typography>
          </Grid>
        </Grid>
  
        {/* Customer Information */}
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={12}>
            <Typography variant="h7" gutterBottom>{t('inv.customerName')}: {invoiceData.customerName}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{t('inv.fsCode')}: {invoiceData.fsCode}</Typography>
          </Grid>
        </Grid>
  
        {/* Tickets Table */}
        <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{t('col.date')}</TableCell>
                <TableCell>{t('col.ticketNo')}</TableCell>
                <TableCell>{t('inv.tonnage')}</TableCell>
                <TableCell>{t('inv.truckNo')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoiceData.invoiceOcrDetailsList.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{formatDate(row.date)}</TableCell>
                  <TableCell>{row.ticketNo}</TableCell>
                  <TableCell>{row.ton}</TableCell>
                  <TableCell>{row.vehicle}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
        {/* Summary Section */}
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          <Grid item xs={6}>
            <Typography variant="body1">{t('inv.totalTickets')}: {invoiceData.invoiceOcrDetailsList?.length || 0}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{t('inv.totalTons')}: {invoiceData.totalTons}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{t('inv.zoneRate')}: $ {invoiceData.zoneRate}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{t('inv.total')}: $ {invoiceData.total}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{t('inv.less10')}: $ {invoiceData.lessTenPercent}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">{t('inv.finalTotal')}: $ {invoiceData.finalTotal}</Typography>
          </Grid>
        </Grid>
      </Container>
    );
  });

  export default InvoiceDisplay;